exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon-search.link {\n    cursor: pointer;\n}\n\n.association-top h1 {\n    font-size: 3em;\n}\n", ""]);

